import * as React from "react";

import {cs}                from "@Common/react/chain-services";
import {scopedState}       from "@Common/react/scoped-state";
import {UseState}          from "@Common/react/use-state";
import {setCurrentToSaved} from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {setNestedValue}    from "@Common/utils/arr-path";
import {chain}             from "@Common/utils/fs";

export const UnaddressedCopiesLogic = ({initEnrollment, enabled, next}) => cs(

    ["state", (_, next) => UseState({
        getInitValue: () => chain(
            initEnrollment?.distribution_options?.mailing?.unaddressed_copies?.enabled ?? false,
            (_) => ({
                saved  : _,
                current: _,
            })
        ),
        next,
    })],

    ({state}) => next(!enabled ? null : {
        state: scopedState(state, ["current"]),
        enrollmentEditor: {
            $name: "unaddressed-copies",
            valid: true,
            changed: state.value.saved !== state.value.current,
            prepareSave: (enrollment) => ({
                newValue: setNestedValue(enrollment, ["distribution_options", "mailing", "unaddressed_copies", "enabled"], state.value.current),
                onSaved: () => setCurrentToSaved(state),
            }),
        },
    }),
);
